import { shallowRef } from 'vue';

import { CurrencyType, ServiceType } from '@/gql/graphql';
import type { ListType } from '@/models/app';
import { paymentService } from '@/services/payment';
import { log } from '@/Utils/logger';

type PaymentTierRow = Awaited<ReturnType<typeof paymentService.fetchPaymentTiers>>[number];

const paymentTiers = shallowRef<PaymentTierRow[]>([]);

const normalizePaymentTier = (tiers: PaymentTierRow[]): PaymentTierRow[] =>
  tiers.map((tier) => ({
    ...tier,
    // Backend may return uppercase values (e.g. "USD") while GraphQL enums are lowercase ("usd").
    currency: String(tier.currency).toLowerCase() as CurrencyType,
    service: String(tier.service).toLowerCase() as ServiceType,
  }));

/** Load once at app initialization (e.g. DashboardLayout). */
export const loadPaymentTiers = () => {
  paymentService
    .fetchPaymentTiers()
    .then((tiers) => {
      paymentTiers.value = normalizePaymentTier(tiers);
    })
    .catch((error) => log.error({ func: 'loadPaymentTiers', error }, 'failed to fetch payment tiers'));
};

export const getPaymentTiersOptions = (service: ServiceType, currency: CurrencyType = CurrencyType.Usd): ListType[] =>
  paymentService.mapPaymentTiersToOptions(
    paymentTiers.value.filter((tier) => tier.service === service && tier.currency === currency),
  );
